module.exports = __webpack_public_path__ + "img/50x50_sari.44e1d0dd.png";